import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { tabulation } from "@/mixins/index";
import { jlParams, deleteJlParams } from "@/api/financial/consumptionDetails";
import addJlparams from "./components/addJlparams";
export default {
  name: "jlparams",
  components: {
    addJlparams: addJlparams
  },
  mixins: [tabulation],
  data: function data() {
    return {
      searchData: {},
      tableData: [],
      value2: [],
      total: 0,
      page: 1,
      sels: [],
      selsString: '',
      InitializeOrNot: false,
      adPlacementSingleChoice: true
    };
  },
  created: function created() {},
  methods: {
    handleCurrentChange: function handleCurrentChange(val) {
      this.searchData.page = val;
      this.searchClick();
    },
    searchClick: function searchClick() {
      var _this = this;

      var searchData = JSON.parse(JSON.stringify(this.searchData));
      searchData.ad_placement = searchData.ad_placement == 'valuets' ? [''] : searchData.ad_placement;
      this.reqLoading = true;
      jlParams(searchData).then(function (res) {
        if (res.code == 200) {
          var list = ['game', 'platform', 'channel', 'pkg', 'ad_channel', 'ad_placement'];
          _this.tableData = res.data.length ? _this.$utils.dataConversion(res.data, list) : [];
          res.data.map(function (i) {
            i.refresh_token = i.refresh_token ? _this.zhuan(i.refresh_token) : '/';
            i.access_token = i.access_token ? _this.zhuan(i.access_token) : '/';
          });

          _this.$nextTick(function () {
            _this.getTableRight();
          });
        }
      }).finally(function () {
        _this.reqLoading = false;
      });
    },
    zhuan: function zhuan(value) {
      var reg = /^(\d{3})(\d*)(\d{3})$/;
      var str = value.replace(reg, function (a, b, c, d) {
        return b + c.replace(/\d/g, "*") + d;
      });
      return str;
    },
    handleSource: function handleSource(id) {
      this.$refs.addJlparams.init(id);
    },
    handleSelectionChange: function handleSelectionChange(val) {
      var _this2 = this;

      this.sels = [];
      val.forEach(function (e) {
        _this2.sels.push(e.id);
      });
      this.selsString = this.sels;
    },
    handleDelete: function handleDelete(ids) {
      var _this3 = this;

      // let id = ids.toString()
      this.$confirm("此操作将删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                deleteJlParams({
                  ids: ids
                }).then(function (res) {
                  if (res.code == 200) {
                    _this3.searchClick();

                    _this3.$message({
                      type: "success",
                      message: "删除成功!"
                    });
                  }
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    }
  }
};